module.exports = "/_next/static/images/Swoosh-04fc9102578d4b2924a03745c7272a22.svg";